import { Link, LinkProps } from 'react-router-dom';
import { useLocalizedPath } from '@/hooks/useLocalizedPath';
import { forwardRef } from 'react';

interface LocalizedLinkProps extends Omit<LinkProps, 'to'> {
  to: string;
}

const LocalizedLink = forwardRef<HTMLAnchorElement, LocalizedLinkProps>(
  ({ to, ...props }, ref) => {
    const { localePath } = useLocalizedPath();
    
    // Don't localize external links or anchors
    if (to.startsWith('http') || to.startsWith('#') || to.startsWith('mailto:') || to.startsWith('tel:')) {
      return <Link ref={ref} to={to} {...props} />;
    }

    return <Link ref={ref} to={localePath(to)} {...props} />;
  }
);

LocalizedLink.displayName = 'LocalizedLink';

export default LocalizedLink;
